
const domain = "https://drpatho.adattraders.in/api/public";
export { domain };

